module.exports = __webpack_public_path__ + "images/appdownload-logo6f76689c6ace18760f33ae526515c18f.png";